<div style="height: 100%; padding: 0.5rem; display: flex; flex-direction: column;">

  <p-galleria *ngIf="showGallery" [value]="images" [showItemNavigators]="true" [circular]="true" [numVisible]="7"
    [(activeIndex)]="activeIndex">
    <ng-template #item let-item>
      <div class="flex flex-col w-full">
        <img [src]="item.safeUrl" id="gallery-main-image"
          style="display: block; width: 100%; object-fit: scale-down; height: calc(80vh - 300px);" />
        <div class="grow"></div>
        <div
          style="width: 100%; display: flex; align-items: center; background-color: rgba(127,127,127,.5); height: 48px;">
          <div style="flex-grow: 1; margin-left: 2rem;">{{ item.fileName }}</div>
          <div class="flex flex-row gap-2">
            <p-checkbox [(ngModel)]="item.isPrimary" id="isPrimary" inputId="isPrimary" [binary]="true"
              (ngModelChange)="primaryChange(item)" class="mt-3"></p-checkbox><label for="isPrimary"
              class="mt-3">Primary</label>
            <p-button type="button" [disabled]="!canMakeThumbnail(item)" color="white" [rounded]="true"
              (click)="makeThumbnail(item)" icon="pi pi-thumbs-up" title="Make New Thumbnail"></p-button>
            <p-button [disabled]="item.isThumbnail" color="white" (click)="edit(item)" title="Edit" icon="pi pi-pencil"
              [rounded]="true"></p-button>
            <p-button *ngIf="canDelete" color="white" (click)="deleteImage(item)" title="Delete" icon="pi pi-trash"
              [rounded]="true"></p-button>
            <p-button color="white" (click)="gal_file.click()" title="Upload" icon="pi pi-upload"
              [rounded]="true"></p-button>
            <a style="color: white; text-decoration: none; min-height: 35px;" class="p-button-rounded" pButton
              [href]="item.safeUrl" target="_self" [download]="item.fileName" title="Download"
              icon="pi pi-download"></a>
            <ng-container *ngIf="params.enableSave">
              <p-button type="button" color="white" [rounded]="true" (click)="save(item)" label="OK"></p-button>
              <p-button type="button" color="white" [rounded]="true" (click)="close()" label="Cancel"></p-button>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #thumbnail let-item>
      <img [src]="item.safeUrl" style="display: block; width: 100%; max-height: 130px; object-fit: scale-down;" />
    </ng-template>
  </p-galleria>

  <input style="visibility: hidden; width: 1px; height: 1px; padding: 0" type="file"
    accept="image/png,image/jpeg,image/webp,.png,.jpeg,.jpg,.webp" id="gal_file" #gal_file name="gal_file" multiple
    (change)="addFiles($event)" />

  <app-image-edit *ngIf="showEdit" [cropInput]="cropInput" (cancel)="cropCancel()"
    (ok)="cropOk($event)"></app-image-edit>

</div>